import { CONTENT_BOARD_BG_SHAPE_ID } from 'features/content-whiteboard/constants';
import type { Editor } from '@digitalsamba/tldraw';

export type InitBgBoundsOptions = {
  editor: Editor | null;
  size: { width: number; height: number };
};

export const initializeBackgroundBounds = ({ editor, size }: InitBgBoundsOptions) => {
  if (!editor) {
    return;
  }

  const { width, height } = size;

  if (width === 0 || height === 0) {
    return;
  }

  const shapeData = {
    id: CONTENT_BOARD_BG_SHAPE_ID,
    type: 'inactive-image',
    x: 0,
    y: 0,
    isLocked: true,
    index: 'a1',
    opacity: 0,
    props: {
      w: width,
      h: height,
    },
  } as any;

  try {
    const existing = editor.getShape(CONTENT_BOARD_BG_SHAPE_ID as any);

    if (existing) {
      editor.updateShape(shapeData);
    } else {
      editor.createShape(shapeData);
    }

    editor.sendToBack([CONTENT_BOARD_BG_SHAPE_ID]);
  } catch (e) {
    console.error(e);
  }
};
